export default function createLogin(element: HTMLElement) {
	Promise.all([import('react'), import('react-dom'), import('./login')]).then(
		([React, ReactDOM, { default: Login }]) => {
			let next;
			if ('URL' in window) {
				next = new URL(window.location.href).searchParams.get('next');
			}
			ReactDOM.render(
				<Login redirectURL={next || window.kaUtion.profileURL} />,
				element,
			);
		},
	);
}
